import {store} from '../../utilities'
import {useEffect} from 'react'
import {setDropdowns} from '../../action_creators'
import {auth} from '../../../Auth'

export default function useFormEffect(subscribe, subscribeResources, id) {
   const state = store.getState();
  useEffect(function () {
    return subscribe(
      {
        paths: [{collection: 'forms'}],
        options: {
          where: [
            {field: 'active', test: '==', value: true},
            {field: 'organization.id', test: '==', value: auth.sunkaizenUser.organization.id},
          ],
        },
      },
      'forms'
    )
  }, [])

  useEffect(
    function () {
      const formsMap = {}
      for (let form of subscribeResources.forms || []) {
        if (form?.deleted && form.deleted === true) {
          // console.log('skipping deleted form', form?.id)
          // console.log('skipping deleted form 2', state?.projectBase?.intake?.id)
          // console.log('id',id)
          if (!id || (id && state?.projectBase?.intake?.id  !== form?.id)) {
            //console.log('skipping edited form same project', form?.id)
            continue
          }
        }
        formsMap[form.id] = form
      }
      store.dispatch(setDropdowns('forms', formsMap))
    },
    [subscribeResources.forms]
  )
}
